import { createAction, createReducer } from '@reduxjs/toolkit';
import { get, isEmpty, concat } from 'lodash-es';

const MODULE_PREFIX = ` [ FUNDS TRANSACTION SCREEN ] `;

const Actions = {
	fetchTransactionHistory: `${MODULE_PREFIX} fetchTransactionHistory`,
	setTransactionHistory: `${MODULE_PREFIX} setTransactionHistory`,
	fetchWithdrawTransactionDetail: `${MODULE_PREFIX} fetchWithdrawTransactionDetail`,
	setWithdrawTransactionDetail: `${MODULE_PREFIX} setWithdrawTransactionDetail`,
	fetchLoadMoreTransactionHistory: `${MODULE_PREFIX} fetchLoadMoreTransactionHistory`,
	// PAYIN DETAIL
	fetchPayinTransactionDetail: `${MODULE_PREFIX} fetchPayinTransactionDetail`,
	setPayinTransactionDetail: `${MODULE_PREFIX} setPayinTransactionDetail`,
};

export const fetchTransactionHistory = createAction(
	Actions.fetchTransactionHistory,
);
export const setTransactionHistory = createAction(
	Actions.setTransactionHistory,
);
export const fetchWithdrawTransactionDetail = createAction(
	Actions.fetchWithdrawTransactionDetail,
);
export const setWithdrawTransactionDetail = createAction(
	Actions.setWithdrawTransactionDetail,
);
export const fetchLoadMoreTransactionHistory = createAction(
	Actions.fetchLoadMoreTransactionHistory,
);

export const fetchPayinTransactionDetail = createAction(
	Actions.fetchPayinTransactionDetail,
);
export const setPayinTransactionDetail = createAction(
	Actions.setPayinTransactionDetail,
);

// =========================Selector
export const getTransactionListData = (state, transactionType) => {
	return get(state, `transactionHistory.${transactionType}`, {});
};
export const getTransactionDetail = (state) => {
	return get(state, 'transactionHistory.transactionDetail', {});
};
export const getPayInTransactionDetail = (state) => {
	return get(state, 'transactionHistory.payinTransactionDetail', {});
};
//==========================Selector
const initialState = {
	all: {},
	payin: {},
	payout: {},
	transactionDetail: {
		data: {},
	},
	payinTransactionDetail: {
		data: {},
	},
};

export default createReducer(initialState, (builder) => {
	builder.addCase(setTransactionHistory, (state, action) => {
		const { transactionType = '' } = action.payload;

		if (state[transactionType]) {
			state[transactionType] = {
				...state[transactionType],
				...action.payload,
			};
		} else {
			state[transactionType] = action.payload;
		}
	});
	builder.addCase(setWithdrawTransactionDetail, (state, action) => {
		state.transactionDetail = {
			...state.transactionDetail,
			...action.payload,
		};
	});
	builder.addCase(setPayinTransactionDetail, (state, action) => {
		state.payinTransactionDetail = {
			...state.payinTransactionDetail,
			...action.payload,
		};
	});
});
